import { render, staticRenderFns } from "./TestData.vue?vue&type=template&id=025c301a&"
import script from "./TestData.vue?vue&type=script&lang=js&"
export * from "./TestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports